<template>
<!-- 店铺信息 -->
<section class="viewContainer">
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
    </div>
    <el-collapse-transition>
      <div v-show="show3">
        <el-form :model="filters" :inline="true" class="findform">
          <!-- 顶部搜索框 -->
          <el-form-item style="display:flex;width:30%" label="关键词：">
            <el-input v-model="filters.name" placeholder="请输入店铺名称、负责人、负责人联系电话" style="width:90%"/>
          </el-form-item>
          <el-form-item style="display:flex;width:30%" label="所属城市：">
            <!-- <el-button style="float:right;height:36px;line-height:1px" @click="onSubmit">查询</el-button> -->
            <el-cascader v-model="filters.chengshi" :options="options" placeholder="请选择城市" style="width:90%"
              filterable clearable @change="handleChange"/>
          </el-form-item>
          <!-- <el-form-item style="display:flex;width:33.3%" label="负责人电话：">
            <el-input v-model="phone" maxlength="11" placeholder="请输入负责人电话"
              onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"/>
          </el-form-item> -->
          <!-- <el-form-item style="display:flex;width:33.3%" label="代 理 品 牌：">
            <el-select v-model="brandId1" placeholder="请选择" filterable style="background:#fff;width:100%" ref="mySelect1">
              <el-option :value="item.Id" :label="item.Name" v-for="(item,index) in brandoptions" :key="index"/>
            </el-select>
          </el-form-item> -->
          <el-form-item style="display:flex;width:30%" label="开店日期：">
            <el-date-picker type="daterange" v-model="value6" :title="value6" @change="changetime" style="width:90%;"
              value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
          </el-form-item>
        </el-form>
        <el-form :inline="true" :model="filters" class="findform">
          <el-form-item style="display:flex;width:30%" label="状　态：">
            <el-select v-model="filters.status" placeholder="请选择" filterable style="width:90%" ref="mySelect1">
              <el-option :value="item.Id" :label="item.Name" v-for="(item,index) in statedarr" :key="index"/>
              <!-- <el-option label="小程序" value="beijing"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item style="display:flex;width:30%;" label="店铺类型：">
            <el-select v-model="filters.shopType" filterable placeholder="请选择" style="width:90%">
              <el-option v-for="(item,index) in shopTypeArr" :key="index" :label="item.Name" :value="item.Id" />
            </el-select>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <!-- <div style="margin: 15px 0 10px 20px;" v-if="authority.some(item => contentkjcz.includes(item))">
      <b>快捷操作</b>
      <div style="margin-top:15px;border-bottom: 1px solid #eee;padding-bottom:15px">
        
      </div>
    </div> -->
    <section class="model_section">
      <p class="model_top_title">店铺管理</p>
      
      <div style="float: right;margin-right: 10px;">
        <el-button type="danger" size="medium" @click="BBStatus(1)"
         v-if="authority.indexOf('enabledbatch')>-1" data-btnmark="enabledbatch">启用</el-button>
        <el-button type="danger" size="medium" @click="BBStatus(2)"
         v-if="authority.indexOf('disablebatch')>-1" data-btnmark="disablebatch">停用</el-button>
        <el-button type="danger" size="medium" @click="OpenShop(1)"
         v-if="authority.indexOf('openbatch')>-1" data-btnmark="openbatch">开店</el-button>
        <el-button type="danger" size="medium" @click="OpenShop(2)"
         v-if="authority.indexOf('closebatch')>-1" data-btnmark="closebatch">闭店</el-button>
        <el-button type="danger" size="medium" @click="OpenBrandBusinessSetType()"
         v-if="authority.indexOf('setlevel')>-1" data-btnmark="setlevel">设置店铺等级</el-button>
        <el-button type="danger" size="medium" @click="addPartner()"
         v-if="isenterpriseadmin==1&&authority.indexOf('add')>-1" data-btnmark="add">添加店铺</el-button>
      </div>
      <!-- <el-button type="danger" size="medium" @click="showAdd()" v-if="menuAction.indexOf(117)>-1&&(userType == 5||BbId == 1)">
          新 增
        </el-button> -->
      <!-- <el-button type="danger" size="medium" @click="showAdd()" v-if="menuAction.indexOf(117)>-1&&(userType == 5||BbId == 1)">
        +新增
      </el-button> -->
    </section>
    <div class="table_container">
      <el-table :data="imageData" stripe border @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" width="55"/>
        <el-table-column label="序号" align="center" width="60">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="店铺名称" align="center">
          <template scope="scope">
          <span class="spanList" :title="scope.row.Name">{{scope.row.Name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属城市" align="center">
          <template scope="scope">{{scope.row.CityName}}</template>
        </el-table-column>
        <el-table-column label="类型" align="center" width="100">
          <template scope="scope">{{scope.row.BbTypeName}}</template>
        </el-table-column>
        <el-table-column label="负责人姓名" align="center" width="120">
          <template scope="scope">{{scope.row.Contacts}}</template>
        </el-table-column>
        <el-table-column label="负责人电话" align="center" width="120">
          <template scope="scope">{{scope.row.Phone}}</template>
        </el-table-column>
        <el-table-column label="所属主体" align="center">
          <template scope="scope">
            <span class="spanList" :title="scope.row.EName">{{scope.row.EName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="店铺级别" align="center" width="100">
          <template scope="scope">{{scope.row.TypeName}}</template>
        </el-table-column>
        <el-table-column label="开店日期" align="center" width="100">
          <template scope="scope">{{scope.row.OpenTime}}</template>
        </el-table-column>
        <el-table-column label="店铺状态" align="center" width="100" v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
          <!-- <template slot-scope="scope">
            <span :class="{red:scope.row.StatusName == '过期'}">{{scope.row.StatusName}}</span>
          </template>-->
          <template scope="scope">
            <span :class="{red:scope.row.StatusName == '过期'}">{{scope.row.StatusName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="280px">
          <template slot-scope="scope">
            <div class="action_container">
              <span @click="handleSwitch(scope.row)" v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1"
                :style="scope.row.PaidPromotionDataOpen?'color: #F56C6C':'color: #3396fb'">
                <i class="el-icon-data-line"></i> {{scope.row.PaidPromotionDataOpen?"关数据":"开数据"}}
              </span>
              <!-- <p class="handle" @click="see(scope.row)"
                v-if="menuAction.indexOf(116)>-1&&(scope.row.StatusId == 1||scope.row.StatusId == 2||scope.row.StatusId == 3||scope.row.StatusId == 5)">
                <i class="el-icon-view"></i> 查看
              </p> -->
              <p class="handle" @click="chakan(scope.row)" data-btnmark="edit"
                v-if="authority.indexOf('edit')>-1&&(scope.row.StatusId == 1||scope.row.StatusId == 2||scope.row.StatusId == 3)">
                <i class="el-icon-edit-outline"></i> 管理
              </p>
              <!-- <p v-if="menuAction.indexOf(119)>-1&&scope.row.Id != 1">
                <el-switch v-model="scope.row.open" v-if="scope.row.open==true"
                  :disabled="scope.row.StatusId ==1||scope.row.StatusId ==2?false:true"
                  active-color="#F56C6C" inactive-color="#ddd"
                  active-text="开启" inactive-text
                  @change="xiugai(scope.row)"/>
                <el-switch v-model="scope.row.open" v-else
                  :disabled="scope.row.StatusId ==1||scope.row.StatusId ==2?false:true"
                  active-color="#F56C6C" inactive-color="#ddd"
                  active-text="关闭" inactive-text
                  @change="xiugai(scope.row)"/>
              </p> -->
              <p class="handle" @click="xiugai(scope.row)" data-btnmark="enabledordisable"
              v-if="authority.indexOf('enabledordisable')>-1&&(scope.row.StatusId == 1||scope.row.StatusId == 2)">
                <i :class="scope.row.StatusId == 1?'el-icon-remove-outline':'el-icon-circle-check'"></i>
                {{scope.row.StatusId == 1?'停用':'启用'}}
              </p>

              <!-- <p class="handle" @click="shenhe(scope.row)"
                v-if="menuAction.indexOf(1166)>-1&&scope.row.StatusId == 4&&scope.row.Id != 1">
                <i class="el-icon-view"></i> 审核
              </p> -->
              <!-- <p class="handle" @click="deleteBb(scope.row)"
                v-if="menuAction.indexOf(1167)>-1&&scope.row.StatusId == 5&&scope.row.Id != 1">
                <i class="el-icon-delete"></i> 删除
              </p> -->
              <p class="handle" @click="setUp(scope)" data-btnmark="openone"
                v-if="authority.indexOf('openone')>-1&&(scope.row.StatusId == 1)">
                <i class="el-icon-bell"></i>
                {{scope.row.IsOpen==1?"闭店":"开店"}}
              </p>
              <!-- <p v-if="scope.row.StatusId == 1 &&(userType == 5||BbId == 1)&&scope.row.Id != 1"
                class="handle" @click="Authentication(scope)">
                <i class="el-icon-circle-check"></i>
                {{scope.row.IsCertificate==1?"取消认证":"确定认证"}}
              </p> -->
              <!-- <p @click="upordown(1,scope)" style="color:#6786b4;margin-left:8px;cursor: pointer;">
                <i class="el-icon-upload2"/>向上
              </p>
              <p @click="upordown(2,scope)" style="color:#6786b4;margin-left:8px;cursor: pointer;">
                <i class="el-icon-download"/>向下
              </p> -->
              <!-- <p @click="moveUp(scope.$index,scope.row)" :disabled="scope.$index===0"
              :style="{color: scope.$index === 0 ? '#ccc' : '#6786b4'}" style="color:#6786b4;margin-left:8px;cursor: pointer;">
                <i class="el-icon-upload2"/>向上
              </p>
              <p @click="moveDown(scope.$index,scope.row)" :disabled="scope.$index===(imageData.length-1)"
              :style="{color: scope.$index === (imageData.length - 1) ? '#ccc' : '#6786b4'}" style="color:#6786b4;margin-left:8px;cursor: pointer;">
                <i class="el-icon-download"/>向下
              </p> -->
              <!-- <p class="handle" v-if="scope.row.Id == 1">内置店铺，不可编辑</p> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :page-size="10" :current-page="pageIndex" :total="total" style="float:right;margin: 10px 0;"/>
    </div>
  </div>
  <!--新增界面-->
  <el-col :span="24" class="add_banner" v-show="isAdd">
    <section>
      <el-col :span="24" style>
        <p style="width:102px">{{typenum == 1?"店铺管理新增":"店铺管理编辑"}}</p>
      </el-col>
    </section>
    <el-form style="margin-left:40px;" :model="form" label-width="130px" ref="editForm">
      <el-form-item label="商家名称：" :required="bloon" :show-message="bloon1" prop>
        <el-input v-model="form.name" auto-complete="off" style="width:560px"/>
      </el-form-item>
      <el-form-item label="代理品牌：" :required="bloon" :show-message="bloon1" prop>
        <span class="choice" @click="choice()">选择</span>
        <div v-show="showBdName">
          <span style="color:#F56C6C">已选择：</span>
          <span v-for="(item,index) in xuanze" :key="index">{{item.Name}};</span>
        </div>
      </el-form-item>
      <el-form-item label="公司所在地：" :required="bloon" :show-message="bloon1" prop>
        <el-select v-model="form.ProvinceId" placeholder style="width:140px">
          <el-option :value="item.Id" :label="item.Name" v-for="(item,index) in provinceoptions" :key="index"/>
          <!-- <el-option label="天津" value="tinajin"></el-option> -->
        </el-select>
        <span style="margin:0 11px" class="dur_title">省</span>
        <el-select v-model="form.CityId" placeholder style="width:140px;">
          <el-option :value="item.Id" :label="item.Name" v-for="(item,index) in cityoptions" :key="index"/>
          <!-- <el-option label="西青" value="green"></el-option> -->
        </el-select>
        <span style="margin:0 11px" class="dur_title">市</span>
        <el-select v-model="form.ZoneId" placeholder style="width:140px">
          <el-option :value="item.Id" :label="item.Name" v-for="(item,index) in Zoneoptions" :key="index"/>
          <!-- <el-option label="天津" value="tinajin"></el-option> -->
        </el-select>
        <span style="margin:0 11px" class="dur_title">区/县</span>
        <el-input v-model="form.address" placeholder="请填写详细地址" auto-complete="off" style="width:560px"/>
      </el-form-item>
      <el-form-item label="公司电话" :required="bloon" :show-message="bloon1" prop>
        <el-input v-model="form.OpeningBank" auto-complete="off" style="width:240px"/>
      </el-form-item>
      <el-form-item label="负责人姓名" :required="bloon" :show-message="bloon1" prop>
        <el-input v-model="form.Contacts" auto-complete="off" style="width:240px"/>
      </el-form-item>
      <el-form-item label="联系电话：" :required="bloon" :show-message="bloon1" prop>
        <el-input v-model="form.Phone" auto-complete="off" style="width:240px" type="email"/>
      </el-form-item>
      <el-form-item label="合作类型：" :required="bloon" :show-message="bloon1">
        <el-select v-model="form.operatypeid" placeholder @click="showtime()" style="background:#fff;width:200px">
          <el-option :value="item.Id" :label="item.Name" v-for="(item,index) in coperation" :key="index"/>
          <!-- <el-option label="小程序" value="mini"></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item label="合作周期：" v-show="form.operatypeid==2" prop>
        <el-col :span="4" style="width: 200px;">
          <el-date-picker type="date" v-model="form.date1" placeholder
            :editable="false" value-format="yyyy-MM-dd" style="width: 180px;"/>
        </el-col>
        <!-- <el-col class="line" style="width:40px" :span="1">
          <img src="../../assets/img/aicon10_03.jpg" alt>
        </el-col>-->
        <el-col class="line dur_title" style="width:35px" :span="1">至</el-col>
        <el-col :span="4" style="width: 200px;">
          <el-date-picker v-model="form.date2" placeholder
            :editable="false" value-format="yyyy-MM-dd" style="width: 180px;"/>
        </el-col>
        <!-- <el-col class="line" style="width:40px" :span="1">
          <img src="../../assets/img/aicon10_03.jpg" alt>
        </el-col>-->
      </el-form-item>

      <el-form-item label="回款类型：" :required="bloon" :show-message="bloon1" prop>
        <el-select v-model="form.huikuanid" placeholder style="background:#fff;width:400px">
          <el-option :value="item.Id" :label="item.Name" v-for="(item,index) in huikuanoptions" :key="index"/>
          <!-- <el-option label="小程序" value="mini"></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item
        label="开户银行支行所在地："
        :required="bloon"
        :show-message="bloon1"
        style="margin-left:-22px;"
        label-width="150px;"
        prop>
        <el-select v-model="form.ProvinceylId" placeholder style="width:140px">
          <el-option :value="item.Id" :label="item.Name" v-for="(item,index) in provinceoptions1" :key="index"/>
          <!-- <el-option label="天津" value="tinajin"></el-option> -->
        </el-select>
        <span style="margin:0 11px" class="dur_title">省</span>
        <el-select v-model="form.CityylId" placeholder style="width:140px;">
          <el-option :value="item.Id" :label="item.Name" v-for="(item,index) in cityoptions1" :key="index"/>
          <!-- <el-option label="西青" value="green"></el-option> -->
        </el-select>
        <span style="margin:0 11px" class="dur_title">市</span>
        <el-select v-model="form.ZoneylId" placeholder style="width:140px">
          <el-option :value="item.Id" :label="item.Name" v-for="(item,index) in Zoneoptions1" :key="index"/>
          <!-- <el-option label="天津" value="tinajin"></el-option> -->
        </el-select>
        <span style="margin:0 11px" class="dur_title">区/县</span>
      </el-form-item>
      <el-form-item label="开户银行名称：" :required="bloon" :show-message="bloon1" prop>
        <el-input v-model="form.BankName" auto-complete="off" style="width:240px"/>
      </el-form-item>
      <el-form-item label="账号名称：" :required="bloon" :show-message="bloon1" prop>
        <el-input v-model="form.accountName" auto-complete="off" style="width:360px" type="tel"/>
      </el-form-item>
      <el-form-item label="公司银行账号：" :required="bloon" :show-message="bloon1" prop>
        <el-input v-model="form.BankNo" auto-complete="off" style="width:360px" type="tel"/>
      </el-form-item>
      <el-form-item label="纳税人识别号：" prop>
        <el-input type="email" v-model="form.TaxpayerAccount" auto-complete="off" style="width:180px"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="margin-left:130px">
      <!-- <p @click.native="editSubmit">新 增</p> -->
      <p @click="showBan()" class="search_btn" v-if="save">新增</p>
      <p @click="editBan()" class="search_btn" v-else>保存</p>
      <p @click="closeBan()" class="search_btn">取消</p>
      <!-- <p @click="showBan()">取 消</p> -->
    </div>
  </el-col>
  <!--点击选择弹框-->
  <el-dialog title="代理品牌" :visible.sync="outerVisible" class="overflow"
    style="width:1545px;margin-left:205px;margin-top:50px;">
    <div>
      <el-input placeholder="请输入关键字" v-model="key1" style="width:250px;" type="email"></el-input>
      <span class="span" style="cursor:pointer" @click="find()">查询</span>
      <span @click="sure" style="cursor:pointer" class="span">确认</span>
      <span @click="outerVisible = false" style="cursor:pointer" class="span">取消</span>
    </div>
    <div class="bdname">
      <span style="margin-left:20px;">品牌名称</span>
    </div>
    <div class="check_box">
      <template>
        <!-- <el-checkbox :indeterminate="false"  v-model="checkAll" text-color="#F56C6C" @change="handleCheckAllChange">全选</el-checkbox> -->
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group
          fill="#F56C6C"
          @change="handleCheckedCitiesChange1"
          v-model="checkedCities"
          text-color="#fff">
          <el-checkbox class="shezhi" style="margin-top:10px;" text-color="#F56C6C"
          :label="city" :title="city.Name" v-for="(city,index)  in cities" :key="index">{{city.Name}}</el-checkbox>
        </el-checkbox-group>
      </template>
    </div>
    <div class="allchange">
      <el-checkbox v-model="checkAll" :indeterminate="false" text-color="#F56C6C" style="margin-top:10px;"
        @change="handleCheckAllChange">全选</el-checkbox>
      <span @click="clear()" ref="clear" style="cursor:pointer" class="span1">清空</span>
    </div>
    <el-dialog width="30%" title="内层 Dialog" :visible.sync="innerVisible" append-to-body></el-dialog>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="outerVisible = false">取 消</el-button>
      <el-button type="primary" @click="innerVisible = true">打开内层 Dialog</el-button>-->
    </div>
  </el-dialog>
  <!--点击确认-->
  <el-dialog title="确认" :visible.sync="dialogVisible1" width="30%">
    <span style="margin-left:140px;display:inline-block;height:100px;line-height:100px" >代理品牌选择完成，您是否选择确认？</span>
    <span slot="footer" class="dialog-footer">
      <el-button class="button" @click="dialogVisible1 = false">取 消</el-button>
      <el-button type="primary" class="button" @click="sure1()">确 定</el-button>
    </span>
  </el-dialog>
  <!--点击取消-->
  <el-dialog title="取消" :visible.sync="dialogVisible2" width="30%">
    <span style="margin-left:40px;display:inline-block;height:100px;line-height:100px">代理品牌选择完成，取消后将不记载您的数据，您是否确定取消么？</span>
    <span slot="footer" class="dialog-footer">
      <el-button class="button" @click="dialogVisible2 = false;">取 消</el-button>
      <el-button type="primary" class="button" @click="sure2()">确 定</el-button>
    </span>
  </el-dialog>
  <!--点击清空-->
  <el-dialog title="清空" :visible.sync="dialogVisible3" width="30%">
    <span style="margin-left:85px;display:inline-block;height:100px;line-height:100px">清空后将不保留您选择的代理品牌结果，您是否确认？</span>
    <span slot="footer" class="dialog-footer">
      <el-button class="button" @click="dialogVisible3 = false">取 消</el-button>
      <el-button type="primary" class="button" @click="clear1()">确 定</el-button>
    </span>
  </el-dialog>
  <!-- 删除弹框 -->
  <el-dialog title="提示" :visible.sync="dialogVisibledelete" width="30%">
    <span>确定删除么？</span>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" class="button" @click="deletesure()">确 定</el-button>
      <el-button class="button" @click="dialogVisibledelete = false">取 消</el-button>
    </span>
  </el-dialog>
  <!-- 弹窗 -->
  <el-dialog title="佣金设置" :visible.sync="dialogVisible" center custom-class="normal_dialog" width="490px">
    <div class="content">
      <div class="input_item">
        <label>店铺分佣比例：</label>
        <!-- <el-input placeholder v-model="fenyong" style="width: 150px"></el-input> -->
        <el-input v-model="enterfenyong" auto-complete="off" style="width:150px" @change="fenyongnum" maxlength="2"
          onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"/>
        <i class="fu_hao">%</i>
      </div>
      <div class="input_item">
        <label>旗下共创端分佣比例：</label>
        <el-input v-model="entergongchaung" placeholder :disabled="true" maxlength="2" @change="gongchuangnum"
          onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')" style="width: 150px"/>
        <i class="fu_hao">%</i>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="setyongjin" class="confirm_btn">确 定</el-button>
      <el-button @click="dialogVisible = false" class="cancle_btn">取 消</el-button>
    </span>
  </el-dialog>
  <!-- 设置店铺付款订单微信收款账户-弹框 -->
  <el-dialog title="设置店铺付款订单微信收款账户" :center="true" class="add_order_cancle" width="35%" :visible.sync="isToExamine">
    <el-form>
      <div v-loading="translateLoading" class="imgDialog">
        <img :src="showImageUrl"/>
        <p>已绑定收款账户员工: <span>用户名: {{BindWxStaffName}} 用户电话: {{BindWxStaffPhone}} </span></p>
      </div>
    </el-form>
    <div style="padding-left:0;text-align:center;margin-top:20px;">
    <button type="button" @click="isToExamine = false"
      class="el-button el-button--default cancle normal_btn">关闭</button>
    </div>
  </el-dialog>
  <!-- 合作模型  -->
  <el-dialog title="设置合作模式" :center="true" :visible.sync="hezuo" width="33%">
    <el-form :model="form" class="findform" ref="editForm">
      <el-form-item style="display:flex;width:100%" label="合作模式：" :required="bloon" :show-message="bloon1">
        <el-select v-model="form.operatypeid" placeholder style="background:#fff;">
          <el-option :value="item.Id" :label="item.Name" v-for="(item,index) in coperation" :key="index"/>
        </el-select>
      </el-form-item>
      <el-form-item label="合作时间：" v-show="this.form.operatypeid == 2"
      :required="bloon" :show-message="bloon1" prop style="display:flex;width:100%">
        <el-date-picker type="daterange" v-model="value1" @change="changtime" style="width:100%;display:flex"
          value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
      </el-form-item>
      <el-form-item style="display:flex;width:100%" label="回款类型：" :required="bloon" :show-message="bloon1" prop>
        <el-select v-model="form.huikuanid" placeholder style="background:#fff;">
          <el-option :value="item.Id" :label="item.Name" v-for="(item,index) in orderarr" :key="index"/>
          <!-- <el-option label="小程序" value="mini"></el-option> -->
        </el-select>
      </el-form-item>
    </el-form>
    <div style="text-align:center">
      <el-button style="border:none" @click="hezuo = false">取 消</el-button>
      <el-button type="danger" style="border:none" @click="CooperationType">保 存</el-button>
    </div>
  </el-dialog>
  <!-- 设置店铺等级-弹框 -->
  <el-dialog title="店铺等级" :visible.sync="setType" class="overflow" width="30%">
    <div style="text-align: center;">
      <el-radio-group v-model="effectiveType" v-for="(r_effectiveType, i) in effectiveTypes" :key="i">
        <el-radio style="margin-left: 15px;" :label="r_effectiveType.id">{{r_effectiveType.name}}</el-radio>
      </el-radio-group>
      <div style="margin-top: 30px;">
        <el-button @click="setType = false">取 消</el-button>
      <el-button type="danger" style="border:none" @click="setstorelevel">确认</el-button>
      </div>
    </div>
  </el-dialog>
</section>
</template>
<script>
import { buttongetlist,provincegetcountys } from "../../api/newOss";
import { brandlist, getkind, getUpdateBrandBusinessDisplayOrder, BatchUpdateBBCooperationType,
  addbrand, yongjin, updatebrand, updatestatus, pinpaishang, DeleteBrandBusiness, EditBBShopIsOpenAndIsCertificate,
  BatchUpdateBBStatus, BatchUpdateBBIsOpenShop,} from "../../api/api";
import { getShowAddShopButton, openPaidPromotionData, BrandBusinessSetType, getEffectiveType } from "../../api/attractInvestment";
export default {
  name: 'brand',
  data() {
    return {
      statedarr:[
        {
         Id:0,
         Name:"全部"
        },
        {
          Id:1,
          Name:"开启"
        },{
          Id:2,
          Name:"关闭"
        }
        // ,{
        //   Id:3,
        //   Name:"过期"
        // },{
        //   Id:4,
        //   Name:"待审核"
        // },{
        //   Id:5,
        //   Name:"审核不通过"
        // }
      ],
       form: {
        operatypeid: "",
        data1: "",
        data2: "",
        huikuanid: ""
      },
      hezuo:false,
      brandId1: 0,
      shopTypeArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "品牌建材"
        },
        {
          Id: 2,
          Name: "装修公司"
        }
      ],
      brandoptions: [],
      phone: "",
      brandId: 0,
      tbdcity: [],
      tbdprovince: [],
      provinceId: 0,
      cityId: 0,
      zoneId: 0,
      optionsindex: "",
      options: [],
      show3: true,
      iseditable: false,
      value6: "",
      userType: "",
      BbId: "",
      form: {},
      typenum: 1,
      isset: true,
      deleteId: "",
      dialogVisibledelete: false,
      brandAll: [],
      bloon1: false,
      bloon: true,
      showtime: true,
      ischeck: "",
      showBdName: false,
      xuanze: [],
      key1: "",
      // show:localStorage.checkedCities?true:false,
      agentBrandList: [],
      check: [],

      checkAll: false,
      checkedCities: [],

      cities: [],
      isIndeterminate: true,
      // 开关
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      value4: true,
      dialogVisible: false,
      outerVisible: false,
      innerVisible: false,
      effectiveType: "",
      setType: false,
      effectiveTypes: [],
      filters: {
        name: "",
        chengshi: [0],
        status: 0,
        date1: "",
        date2: "",
        shopType: 0, // 店铺类型
      },
      coperation: "",
      imageData: [],
      total: 100,
      page: 1,
      isdelete: true,
      editFormVisible: false, //编辑界面显是否显示
      showImageUrl: "", // 二维码图片
      form: {
        ProvinceylId: 0,
        CityylId: 0,
        ZoneylId: 0,
        ZoneId: 0,
        TaxpayerAccount: "",
        address: "",
        name: "",
        Phone: "",
        OpeningBank: "",
        BankName: "",
        shopnum: "",
        accountName: "",
        BankNo: "",
        ProvinceId: 0,
        CityId: 0,
        operatypeid: 1,
        date1: "",
        date2: "",
        OperatorId: "",
        huikuanid: 1,
        Contacts: ""
      },
      value1:"",
       orderarr: [
        {
          Id: 1,
          Name: "7天结算"
        },
        {
          Id: 2,
          Name: "订单完成时结算"
        }
      ],
      // 新增页面
      isAdd: false,
      pageIndex: 1,
      pageSize: 10,
      provinceoptions: "",
      provinceoptions1: "",
      cityoptions: [{ Id: 0, Name: "全部" }],
      cityoptions1: [{ Id: 0, Name: "全部" }],
      Zoneoptions: [{ Id: 0, Name: "全部" }],
      Zoneoptions1: [{ Id: 0, Name: "全部" }],
      enterfenyong: "",
      entergongchaung: "",
      yongjinid: "",
      save: true,
      isToExamine: false, // 设置店铺付款订单微信收款账户弹框
      editId: "",
      key: "",
      statusId: "",
      goodIdarr:[],
      BindWxStaffName: "",
      BindWxStaffPhone: "",
      brandStatus: "", // 状态
      huikuanoptions: "",
      hezuotype:"",
      hezuotime1:"",
      hezuotime2:"",
      huikuantype:"",
      translateLoading: false, // 生成店铺绑定金专微信小程序推广二维码
      pickerOptions2: {
        disabledDate: time => {
          let beginDateVal = this.filters.date1;
          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        }
      },
      enterpriseId: '', // 企业id
      newBbType: '', // 企业类型 1=品牌建材、2=装修公司、3=个人设计师
      
      isadmin: localStorage.isadmin, // 是否是超级管理员 0=否 1=是
      isplatformadmin: localStorage.isplatformadmin, // 是否是平台(全国)管理员 0=否 1=是
      iscityadmin: localStorage.iscityadmin, // 是否是城市管理员(城市分公司) 0=否 1=是
      isenterpriseadmin: localStorage.isenterpriseadmin, // 是否是企业管理员 0=否 1=是
      isshopadmin: localStorage.isshopadmin, // 是否是店铺管理员 0=否 1=是
      
      authority: [], // 按钮权限
      contentkjcz: [
        'enabledbatch','disablebatch','openbatch','closebatch','setlevel',
      ],
    };
  },
  methods: {
    // 查询列表
    getbrandlist() {
      var loginParams = {
        key: this.filters.name,
        status: this.filters.status,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        userId: localStorage.Id,
        provinceId: this.provinceId,
        cityId: this.cityId,
        countyId: this.zoneId, // 区县
        brandId: this.brandId1,
        bbType: this.filters.shopType,
        beginTime: this.filters.date1, // 开店开始时间
        endTime: this.filters.date2, // 开店结束时间
      };
      brandlist(loginParams).then(data => {
        this.imageData = data.ResultObj;
        this.total = data.RowsCount;
        for (var obj of this.imageData) {
          if (obj.StatusId == 1) {
            obj.open = true;
          } else {
            obj.open = false;
          }
        }
      }).catch(err => {
        this.imageData = [];
      });
    },
    // 添加店铺
    addPartner() {
      let obj = {
        userId: localStorage.Id
      };
      getShowAddShopButton(obj).then(data => {
        if(data) {
          if (data.resultCode == 1) {
              // this.enterpriseId = data.resultObj.enterpriseId; // 企业id
              this.newBbType = data.resultObj; // 企业类型 1=品牌建材、2=装修公司、3=个人设计师
              this.$router.push({
                path: "/seeFindshop",
                query: {
                  type: 0,
                  storeType: this.newBbType
                }
              });
          }else{
            this.$swal({
              type: "error",
              text:data.resultMsg
            })
            // return false;
          }
        }
      });
    },
    //操作向上   向下
    upordown(val,scope){
       var obj = {
         bbId: scope.row.Id,
         direction: val
       }
       getUpdateBrandBusinessDisplayOrder(obj).then(data=>{
        if(data.ResultCode == 1){
          this.getbrandlist();
        }
        if(data.ResultCode == 0) {
          this.$swal({
            type: "error",
            text:data.ResultMsg
          })
        }
        if(data.ResultCode == 2) {
          this.$swal({
            type: "error",
            text:data.ResultMsg
          })
        }
      })
    },
    // 向上移动
    moveUp(index,row) {
      var that = this;
      console.log('上移',index,row);
      console.log(that.imageData[index]);
      if (index > 0) {
        let upDate = that.imageData[index - 1];
        that.imageData.splice(index - 1, 1);
        that.imageData.splice(index,0, upDate);
        var obj = {
          bbIds: that.imageData.map(item=>item.Id).join(","), // 排序过的店铺id，按顺序以英文逗号分隔，参数示例：190,187,185,184,188,189,186
        }
        getUpdateBrandBusinessDisplayOrder(obj).then(data=>{
          if(data.ResultCode == 1){
            this.getbrandlist();
          }
          if(data.ResultCode == 0) {
            this.$swal({
              type: "error",
              text:data.ResultMsg
            })
          }
          if(data.ResultCode == 2) {
            this.$swal({
              type: "error",
              text:data.ResultMsg
            })
          }
        })
      } else {
        console.log('已经是第一条，不可上移');
      }
    },
    // 向下移动
    moveDown(index,row){
      var that = this;
      console.log('下移',index,row);
      if ((index + 1) === that.imageData.length){
        console.log('已经是最后一条，不可下移');
      } else {
        console.log(index);
        let downDate = that.imageData[index + 1];
        that.imageData.splice(index + 1, 1);
        that.imageData.splice(index,0, downDate);
        var obj = {
          bbIds: that.imageData.map(item=>item.Id).join(","), // 排序过的店铺id，按顺序以英文逗号分隔，参数示例：190,187,185,184,188,189,186
        }
        getUpdateBrandBusinessDisplayOrder(obj).then(data=>{
          if(data.ResultCode == 1){
            this.getbrandlist();
          }
          if(data.ResultCode == 0) {
            this.$swal({
              type: "error",
              text:data.ResultMsg
            })
          }
          if(data.ResultCode == 2) {
            this.$swal({
              type: "error",
              text:data.ResultMsg
            })
          }
        })
      }
    },
    CooperationType(){
      if(this.form.operatypeid == 0){
         this.$swal({
           type:"warning",
           text:"请选选择合作模式"
         })
         return false
      }
      if(this.form.operatypeid == 1){
         this.value1 = []
             var obj = {
        bbIds:this.goodIdarr.join(','),
        userId:localStorage.Id,
        cooperationTypeId:this.form.operatypeid,
        coStartTime: this.value1.length == 0?"":this.value1[0],
        coEndTime:this.value1.length == 0?"":this.value1[1],
        settleTypeId:this.form.huikuanid
      }
      BatchUpdateBBCooperationType(obj).then(data=>{
        if(data.ResultCode == 1){
          this.hezuo = false
          this.$swal({
            type:"success",
            html:data.ResultMsg
          })
           this.getbrandlist();
        }
      })
      }
      if(this.form.operatypeid == 2){
        if(this.form.data1 == ""){
           this.$swal({
             type:"warning",
             text:"请选择合作开始时间"
           })
           return false
        }else if(this.form.data2 == ""){
          this.$swal({
             type:"warning",
             text:"请选择合作结束时间"
           })
           return false
        }
             var obj = {
        bbIds:this.goodIdarr.join(','),
        userId:localStorage.Id,
        cooperationTypeId:this.form.operatypeid,
        coStartTime:this.form.data1,
        coEndTime:this.form.data2,
        settleTypeId:this.form.huikuanid
      }
      BatchUpdateBBCooperationType(obj).then(data=>{
        if(data.ResultCode == 1){
          this.hezuo = false
          this.$swal({
            type:"success",
            text:"操作成功"
          })
           this.getbrandlist();
        }
      })
      }
    },
    OpenShop(val){
          if (this.goodIdarr.length == 0) {
        this.$swal({
          type: "warning",
          text: "请选择需要操作的店铺"
        });
        return false;
      }
       var obj = {
         bbIds:this.goodIdarr.join(','),
         userId:localStorage.Id,
         statusId:val
       }
      BatchUpdateBBIsOpenShop(obj).then(data=>{
        if(data.ResultCode == 1){
          this.$swal({
            type:"success",
            html:data.ResultMsg
          })
           this.getbrandlist();
        }
      }) 
    },
    //设置店铺等级
    OpenBrandBusinessSetType(val){
      if(this.goodIdarr.length===0) {
        this.$swal({
          type:"warning",
          text: '请至少选择一条数据'
        })
        return false;
      }
      this.setType = true;
      getEffectiveType(null).then(data=>{
        if(data.resultCode == 1){
          this.effectiveTypes = data.resultObj;
        }
      })
    },
    //设置店铺等级
    setstorelevel(val){
      if(!this.effectiveType){
          this.$swal({
            type: "warning",
            text:"请选择店铺!",
          });
          return false;
      }
      let obj = {
        bbid:this.goodIdarr,
        typeId:this.effectiveType
      }
      BrandBusinessSetType(obj).then(data=>{
        if(data.resultCode == 1){
          this.$swal({
            type:"success",
            html:data.resultMsg
          })
          this.setType = false;
          this.getbrandlist();
          return;
        }
      })
    },
    // 开数据 & 关数据
    handleSwitch(row) {
      this.$swal({
        type: "warning",
        text: row.PaidPromotionDataOpen ? "是否执行关数据操作" : "是否执行开数据操作",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          // let obj = {
          //   bbid: row.Id // 店铺id
          // }
          openPaidPromotionData('obj', row.Id).then(data=>{
            if(data.ResultCode == 1){
              this.$swal({
                type:"success",
                text:"操作成功"
              })
              this.getbrandlist();
            }
          })
        }
      });
    },
    BBStatus(val){
          if (this.goodIdarr.length == 0) {
        this.$swal({
          type: "warning",
          text: "请选择需要操作的店铺"
        });
        return false;
      }
       var obj = {
         bbIds:this.goodIdarr.join(','),
         userId:localStorage.Id,
         statusId:val
       }
      BatchUpdateBBStatus(obj).then(data=>{
        if(data.ResultCode == 1){
          this.$swal({
            type:"success",
            html:data.ResultMsg
          })
           this.getbrandlist();
        }
      })
    },
    // 点击复选框
    handleSelectionChange(val) {
      if(val.length  == 1){
       this.hezuotype = val[0].CooperationTypeId
       this.hezuotime1 = val[0].CoStarTime+""=="null"?"":val[0].CoStarTime
       this.hezuotime2 = val[0].CoEndTime+""=="null"?"":val[0].CoEndTime
       this.value1 = [this.hezuotime1,this.hezuotime2]
       this.huikuantype = val[0].SettleTypeId
      }else{
      this.hezuotype = 0
      this.hezuotime1 = ""
      this.hezuotime2 = ""
      this.huikuantype = 1
      this.value1 = []
      }
      this.goodIdarr = [];
      this.goodNamearr = [];
      val.forEach(element => {
        this.goodIdarr.push(element.Id);
        this.goodNamearr.push(element.Name);
        this.brandStatus = element.StatusId
        // this.BindWxStaffName = element.BindWxStaffName;
        // this.BindWxStaffPhone = element.BindWxStaffPhone;
      });
    },
    changtime(val){
      if(val==null){
        this.form.data1 = ""
        this.form.data2 = ""
      }else{
        this.form.data1 = val[0]
        this.form.data2 = val[1]
      }
    },
    //获取品牌
    getbrand() {
      let that = this;
      var loginParams = {
        tableName: "tbdbrand",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        that.brandoptions = data;
      });
    },
    // 查询列表页所属城市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
      this.zoneId = val[2]; // 区
    },
    // 查找省市区
    getprovince() {
      let loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        const provinceOptions = [];
        data.resultObj.forEach(item => {
          const province = { value: item.pid, label: item.pname, children: [] };
          if (item.citys && item.citys.length > 0) {
            item.citys.forEach(city => {
              const allCityOption = { value: 0, label: "全市" };
              let cityObj;
              if (city.countys && city.countys.length > 0) {
                cityObj = {
                  value: city.cid, label: city.cname,
                  children: [allCityOption].concat(city.countys.map(zone => ({
                    value: zone.scid, label: zone.scname
                  })))
                };
              } else {
                cityObj = { value: city.cid, label: city.cname, children: [allCityOption] };
              }
              province.children.push(cityObj);
            });
          } else {delete province.children;}
          provinceOptions.push(province);
        });
        this.options = provinceOptions;
        this.options.unshift({value: 0, label: "全国"});
      });
    },

    // 开店日期
    changetime() {
      if (this.value6 + "" == "null") {
        this.value6 = ["", ""];
      }
      this.filters.date1 = this.value6[0];
      this.filters.date2 = this.value6[1];
    },
    // 开店
    setUp(scope) {
      var obj = {
        bbId: scope.row.Id,
        userId: localStorage.Id,
        operType: 1
      };
      EditBBShopIsOpenAndIsCertificate(obj).then(data => {
        if (data.ResultCode == 1) {
          this.getbrandlist();
          this.$swal({
            type: "success",
            text: data.ResultMsg
          });
        }
      });
    },
    //认证
    Authentication(scope) {
      var obj = {
        bbId: scope.row.Id,
        userId: localStorage.Id,
        operType: 2
      };
      EditBBShopIsOpenAndIsCertificate(obj).then(data => {
        if (data.ResultCode == 1) {
          this.getbrandlist();
          this.$swal({
            type: "success",
            text: data.ResultMsg
          });
        }
      });
    },
    //点击删除
    deleteBb(scope) {
      //  this.dialogVisibledelete = true
      this.deleteId = scope.Id;
      this.isdelete = true;
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(res => {
        if (res.value) {
          this.deletesure();
        }
      });
    },
    deletesure() {
      if (this.isdelete) {
        this.isdelete = false;
        var obj = {
          id: this.deleteId
        };
        DeleteBrandBusiness(obj).then(data => {
          if (data.ResultCode == 1) {
            this.dialogVisibledelete = false;
            this.getbrandlist();
            this.$swal({
              type: "success",
              text: "删除成功"
            });
          }
        });
      }
    },
    //点击查看
    see(scope){
      this.$router.push({
        path: "/examine",
        query: {
          BbId: scope.Id,
          type:1
        }
      });
    },
    //点击审核
    shenhe(scope) {
      this.$router.push({
        path: "/examine",
        query: {
          BbId: scope.Id
        }
      });
    },
    closeBan() {
      this.isAdd = false;
      this.form.name = "";
      this.form.Phone = "";
      this.form.ProvinceId = 0;
      this.form.CityId = 0;
      this.form.OpeningBank = "";
      this.form.BankName = "";
      this.form.BankNo = "";
      this.form.Contacts = "";
      this.form.operatypeid = 1;
      this.form.date1 = "";
      this.form.date2 = "";
      this.form.accountName = "";
      this.form.TaxpayerAccount = "";
      //this.form.OperatorId = this.$cookie.get("OperatorId");
    },
    find() {
      var brands = this.brandAll;
      var searchBrands = [];
      brands.forEach(element => {
        var brandName = element.Name;
        if (
          brandName.indexOf(this.key1) >= 0 ||
          this.key1.indexOf(brandName) >= 0
        ) {
          searchBrands.push(element);
        }
      });
      this.cities = searchBrands;
    },
    //全选本地
    find1() {
      var key = {
        key: this.key1,
        pageIndex: 1,
        pageSize: 100000
      };
      pinpaishang(key).then(data => {
        this.cities = data.ResultObj;
        this.brandAll = this.cities;
        var checkedBrands = [];
        if (localStorage.checkedCities) {
          var tempCheckedBrands = JSON.parse(localStorage.checkedCities);
          for (var i = 0; i < tempCheckedBrands.length; i++) {
            this.cities.forEach(element => {
              var tempBrandId = tempCheckedBrands[i].Id;
              var brandId = element.Id;
              if (tempBrandId === brandId) {
                checkedBrands.push(element);
              }
            });
          }
        }
        this.checkedCities = checkedBrands;
      });
    },
    //确认
    sure() {
      this.dialogVisible1 = true;
    },
    sure1() {
      this.dialogVisible1 = false;
      this.outerVisible = false;
      if (this.ischeck.length > 0) {
        this.showBdName = true;
      } else {
        this.showBdName = false;
      }
      localStorage.checkedCities = JSON.stringify(this.ischeck);
      this.xuanze = JSON.parse(localStorage.checkedCities);
    },
    sure2() {
      this.dialogVisible2 = false;
      this.outerVisible = false;
      this.checkedCities = [];
      this.check = [];
    },
    //清空
    clear() {
      if (this.ischeck.length > 0) {
        this.dialogVisible3 = true;
        this.$refs.clear.style.background = "#F56C6C;";
        this.$refs.clear.style.color = "#fff";
      } else {
        this.dialogVisible3 = false;
        this.$refs.clear.style.background = "#e6e6e6";
        this.$refs.clear.style.color = "#000";
      }
    },
    clear1() {
      //  this.showBdName = false
      this.ischeck = [];
      this.dialogVisible3 = false;
      this.checkedCities = [];
      this.check = [];
      this.checkAll = false;
      this.$refs.clear.style.background = "#e6e6e6";
      this.$refs.clear.style.color = "#000";
      //  localStorage.checkedCities = []
    },
    //选择品牌
    handleCheckAllChange(val) {
      if (val) {
        this.$refs.clear.style.background = "#F56C6C";
        this.$refs.clear.style.color = "#fff";
      } else {
        this.$refs.clear.style.background = "#e6e6e6";
        this.$refs.clear.style.color = "#000";
      }
      this.ischeck = this.cities;
      this.checkedCities = val ? this.cities : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange1(value) {
      this.ischeck = value;
      if (this.ischeck.length > 0) {
        this.$refs.clear.style.background = "#F56C6C";
        this.$refs.clear.style.color = "#fff";
      }
      //  if(value.length>0){
      //     this.showBdName = true
      //  }else{
      //     this.showBdName = false
      //  }

      this.check = value;
      //   localStorage.checkedCities =JSON.stringify(value)
      //  this.xuanze = JSON.parse(localStorage.checkedCities)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    //点击选择
    choice() {
      this.outerVisible = true;
      var loginParams = {
        key: this.key,
        pageIndex: 1,
        pageSize: 100000
      };
      pinpaishang(loginParams).then(data => {
        this.cities = data.ResultObj;
        this.brandAll = this.cities;
        var checkedBrands = [];
        if (localStorage.checkedCities) {
          var tempCheckedBrands = JSON.parse(localStorage.checkedCities);
          for (var i = 0; i < tempCheckedBrands.length; i++) {
            this.cities.forEach(element => {
              var tempBrandId = tempCheckedBrands[i].Id;
              var brandId = element.Id;
              if (tempBrandId === brandId) {
                checkedBrands.push(element);
              }
            });
          }
        }
        this.checkedCities = checkedBrands;
        this.ischeck = this.checkedCities;
        if (this.ischeck.length <= 0) {
          this.$refs.clear.style.background = "#e6e6e6";
          this.$refs.clear.style.color = "#000";
        }
      });
    },
    // 重置
    fnReset() {
      this.filters = {
        name: "",
        chengshi: [0],
        status: 0,
        shopType: 0, // 店铺类型
      },
      this.provinceId = 0;
      this.cityId = 0;
      this.zoneId = 0;
      this.getprovince(); // 获取省市区
      this.brandId1 = 0; // 代理品牌
      // this.pageIndex = 1;
      // this.getbrandlist();
    },
    // 查询
    onSubmit() {
      this.pageIndex = 1;
      this.getbrandlist();
    },
    hide() {
      this.$refs.mySelect.handleClose();
    },
    setting(scope) {
      this.dialogVisible = true;
      this.isset = true;
      this.yongjinid = scope.Id;
      this.entergongchaung = scope.GcdPriceRate;
      this.enterfenyong = scope.PriceRate;
    },
    showAdd() {
      // this.isAdd = true;
      // this.form.ProvinceylId =  0;
      // this.form.CityylId =  0;
      // this.form.ZoneylId = 0;
      // this.form.accountName = "";
      // this.form.TaxpayerAccount = "";
      // this.form.BankNo = "";
      // this.form.name = "";
      // this.form.Phone = "";
      // this.form.ProvinceId = 0;
      // this.form.CityId = 0;
      // this.form.ZoneId = 0
      // this.form.OpeningBank = "";
      // this.form.address = ""
      // this.form.BankName = "";
      // this.form.BankNo = "";
      // this.form.Contacts = "";
      // this.form.operatypeid = 1;
      // this.form.date1 = "";
      // this.form.date2 = "";
      // this.form.OperatorId = this.$cookie.get("OperatorId");
      // this.showBdName = false
      // localStorage.checkedCities = []
      // this.typenum = 1
      this.$router.push({
        path: "/findshop"
      });
      localStorage.businessBbId = 0;
    },
    //新增
    showBan() {
      if (this.form.name == "") {
        this.$notify({
          title: "警告",
          message: "请输入商家名称",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.checkedCities == "") {
        this.$notify({
          title: "警告",
          message: "请选择代理品牌",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.ProvinceId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择省",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.CityId === 0) {
        this.$notify({
          title: "警告",
          message: "请选择市",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.ZoneId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择区",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.address == "") {
        this.$notify({
          title: "警告",
          message: "请填写具体位置",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.OpeningBank == "") {
        this.$notify({
          title: "警告",
          message: "请填写公司电话",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.Contacts == "") {
        this.$notify({
          title: "警告",
          message: "请填写负责人姓名",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.Phone == "") {
        this.$notify({
          title: "警告",
          message: "请填写联系电话",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.ProvinceylId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择开户银行省",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.CityylId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择开户银行市",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.ZoneylId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择开户银行区",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.BankName == "") {
        this.$notify({
          title: "警告",
          message: "请填写开户银行名称",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.accountName == "") {
        this.$notify({
          title: "警告",
          message: "请填写账号名称",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.BankNo == "") {
        this.$notify({
          title: "警告",
          message: "请填写公司银行账号",
          type: "warning",
          duration: 1200
        });
        return false;
      } else {
        let that = this;
        var loginParams = {
          bankProvinceId: this.form.ProvinceylId,
          bankCityId: this.form.CityylId,
          bankZoneId: this.form.ZoneylId,
          ZoneId: this.form.ZoneId,
          Name: this.form.name,
          address: this.form.address,
          accountName: this.form.accountName,
          Phone: this.form.Phone,
          ProvinceId: this.form.ProvinceId,
          CityId: this.form.CityId,
          telPhone: this.form.OpeningBank,
          BankName: this.form.BankName,
          BankNo: this.form.BankNo,
          Contacts: this.form.Contacts,
          CooperationTypeId: this.form.operatypeid,
          CoStarTime: this.form.date1,
          CoEndTime: this.form.date2,
          SettleTypeId: this.form.huikuanid,
          OperatorId: this.form.OperatorId,
          TaxpayerAccount: this.form.TaxpayerAccount,
          agentBrandList: this.checkedCities ? this.checkedCities : []
        };
        addbrand(loginParams).then(data => {
          if (data.ResultCode == 1) {
            data = data.ResultObj;
            this.checkedCities = [];
            this.isAdd = false;
            this.getbrandlist();
            this.$notify({
              title: "成功",
              message: "添加成功",
              type: "success"
            });
          }
        });
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getbrandlist();
    },
    //获取合作类型
    getoperaoptions() {
      let that = this;
      var loginParams = {
        tableName: "tbdcooperationtype",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        data = data.ResultObj;
        let obj = {
          Id: 0,
          Name: "请选择"
        };
        let newdata = data;
        newdata.unshift(obj);
        this.coperation = data;
        this.form.operatypeid = data[0].Id;
        // this.form.positionId = newdata[0].Id;
      });
    },
    //编辑
    chakan(scope) {
      localStorage.businessBbId = scope.Id;
      localStorage.setItem("businessBbName", scope.Name);
      this.$router.push({
        path: "/findshop",
        query: {
          type: 1,
          storeType: scope.BbType // 店铺类型
        }
      });
    },

    //确定编辑
    editBan() {
      if (this.form.name == "") {
        this.$notify({
          title: "警告",
          message: "请输入商家名称",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.ProvinceId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择省",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.CityId === 0) {
        this.$notify({
          title: "警告",
          message: "请选择市",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.ZoneId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择区",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.address == "") {
        this.$notify({
          title: "警告",
          message: "请填写具体位置",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.OpeningBank == "") {
        this.$notify({
          title: "警告",
          message: "请填写公司电话",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.Contacts == "") {
        this.$notify({
          title: "警告",
          message: "请填写负责人姓名",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.Phone == "") {
        this.$notify({
          title: "警告",
          message: "请填写联系电话",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.operatypeid == 0) {
        this.$notify({
          title: "警告",
          message: "请选择合作类型",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.ProvinceylId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择开户银行省",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.CityylId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择开户银行市",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.ZoneylId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择开户银行区",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.BankName == "") {
        this.$notify({
          title: "警告",
          message: "请填写开户银行名称",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.accountName == "") {
        this.$notify({
          title: "警告",
          message: "请填写账号名称",
          type: "warning",
          duration: 1200
        });
        return false;
      } else if (this.form.BankNo == "") {
        this.$notify({
          title: "警告",
          message: "请填写公司银行账号",
          type: "warning",
          duration: 1200
        });
        return false;
      } else {
        let that = this;
        var loginParams = {
          id: localStorage.otherId,
          bankProvinceId: this.form.ProvinceylId,
          bankCityId: localStorage.CityylId,
          bankZoneId: localStorage.ZoneylId,
          ZoneId: localStorage.ZoneId,
          Name: this.form.name,
          address: this.form.address,
          accountName: this.form.accountName,
          Phone: this.form.Phone,
          ProvinceId: this.form.ProvinceId,
          CityId: this.form.CityId,
          telPhone: this.form.OpeningBank,
          BankName: this.form.BankName,
          BankNo: this.form.BankNo,
          Contacts: this.form.Contacts,
          CooperationTypeId: this.form.operatypeid,
          CoStarTime: this.form.date1,
          CoEndTime: this.form.date2,
          SettleTypeId: this.form.huikuanid,
          OperatorId: this.form.OperatorId,
          TaxpayerAccount: this.form.TaxpayerAccount,
          agentBrandList: JSON.parse(localStorage.checkedCities)
        };
        updatebrand(loginParams).then(data => {
          this.isAdd = false;
          this.checkedCities = [];
          this.$notify.success({
            title: "提示",
            message: "修改成功",
            duration: 1200
          });
          data = data.ResultObj;
          this.getbrandlist();
        });
      }
    },
    xiugai(scope) {
      let that = this;
      let status = "";
      if (scope.StatusId == 1) {
        status = 2;
      } else if (scope.StatusId == 2) {
        status = 1;
      }
      var loginParams = {
        id: scope.Id,
        status: status,
        oper: that.$cookie.get("OperatorId")
      };
      updatestatus(loginParams).then(data => {
        if(data.ResultCode == 1){
          that.getbrandlist();
          this.$swal({
            type:'success',
            text:"操作成功"
          })
        }
      });
    },
    //输入分佣
    fenyongnum(e) {
      if (this.enterfenyong > 100) {
        this.$notify({
          title: "警告",
          message: "输入的数字要小于100",
          type: "warning"
        });
      }
    },
    //设置共创端比例
    gongchuangnum() {
      if (this.entergongchaung > 100) {
        this.$notify({
          title: "警告",
          message: "输入的数字要小于100",
          type: "warning"
        });
      }
    },
    //设置佣金
    setyongjin() {
      if (this.isset) {
        this.isset = false;
        let that = this;
        var re = /^[0-9]+.?[0-9]*/;
        if (!re.test(this.enterfenyong)) {
          this.$swal({
            text: "请输入正确的佣金比例和分拥比例",
            type: "warning"
          });
        } else if (this.entergongchaung > 100) {
          this.$swal({
            text: "输入的数字要小于100",
            type: "warning"
          });
        } else if (this.enterfenyong > 100) {
          this.$swal({
            text: "输入的数字要小于100",
            type: "warning"
          });
        } else if (!re.test(this.entergongchaung)) {
          this.$swal({
            text: "请输入正确的佣金比例和分拥比例",
            type: "warning"
          });
        } else {
          var loginParams = {
            id: this.yongjinid,
            priceRate: this.enterfenyong,
            gcdPriceRate: this.entergongchaung
          };
          yongjin(loginParams).then(data => {
            this.$swal({
              text: "设置成功",
              type: "success"
            });
            that.dialogVisible = false;
            that.getbrandlist();
          });
        }
      }
    },
    //获取回款类型
    gethuikuan() {
      var loginParams = {
        tableName: "tBDBBSettleType",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        data = data.ResultObj;
        this.huikuanoptions = data;
        // this.form.positionId = newdata[0].Id;
      });
    },
    // 按钮权限
    handlebtn(){
      let obj = {
        mark: 'brand',
      };
      buttongetlist(obj).then(data => {
        this.authority = data.resultObj;
      })
    },
  },
  created() {
    this.form.OperatorId = this.$cookie.get("OperatorId");
    this.userType = localStorage.UserType;
    this.BbId = localStorage.BbId;
    this.handlebtn(); // 按钮权限
    this.getbrandlist();
    this.getoperaoptions();
    this.gethuikuan(); // 获取回款类型
    this.getbrand();
    this.getprovince(); // 获取省市区
  },
  // 缓存数据
  beforeRouteEnter(to, from, next) {
    let arrPath = [
      '/findshop',
      '/examine'
    ]
    // if(arrPath.indexOf(from.path) >= 0){
    //   to.meta.init = false;
    // } else {
    //   to.meta.init = true
    // }
    next(vm => {
      vm.getbrandlist()
    })
  },
  activated() {
    if(this.$route.meta.init){
      // 初始化处理
      this.filters = {
        name: "",
        status: 0
      }
      this.options = [
        {
          value: 0,
          label: "全部"
        }
      ],
      this.brandId1 = 0
      this.total = 1
      this.pageIndex = 1;
      this.getbrandlist();
    }
  }
};
</script>
<style scoped>
.is-checked .el-checkbox__label {
  color: #606266;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
.overflow .el-checkbox__label {
  width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
}
.button {
  background: #fff;
  border: 1px solid #F56C6C;
  color: #F56C6C;
}
.button:hover {
  background: #F56C6C;
  border: 1px solid #F56C6C;
  color: #fff;
}
.allchange {
  height: 35px;
  background: #f6f7f9;
  padding-left: 20px;
  margin-top: 30px;
}
.check_box {
  padding-left: 15px;
  height: 200px;
  overflow: hidden;
  overflow-y: scroll;
}
.shezhi {
  width: 80px;
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
}
.bdname {
  width: 100%;
  height: 35px;
  line-height: 35px;
  background: #dedede;
  margin-top: 20px;
}
.span {
  display: inline-block;
  width: 60px;
  height: 35px;
  line-height: 35px;
  border: 1px solid #F56C6C;
  text-align: center;
  color: #F56C6C;
  border-radius: 5px;
  margin-left: 15px;
}
.span:hover {
  background: #F56C6C;
  color: #fff;
  transform: 1s;
}
.span {
  display: inline-block;
  width: 60px;
  height: 35px;
  line-height: 35px;
  border: 1px solid #F56C6C;
  text-align: center;
  color: #F56C6C;
  border-radius: 5px;
  margin-left: 15px;
}
.span:hover {
  background: #F56C6C;
  color: #fff;
  transform: 1s;
}
.span1 {
  display: inline-block;
  width: 50px;
  height: 20px;
  line-height: 20px;
  background: #F56C6C;
  color: #fff;
  text-align: center;

  margin-left: 0px;
}

.choice {
  display: inline-block;
  width: 80px;
  height: 40px;
  border: 1px solid #eee;
  color: #888;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.choice:hover {
  border-color: #F56C6C;
  color: #F56C6C;
}
.fu_hao {
  color: #bebebe;
  margin-left: 5px;
}
.input_item {
  margin-bottom: 15px;
}
.input_item label {
  width: 120px;
  text-align: right;
  display: inline-block;
  color: #bebebe;
  font-size: 12px;
}
.confirm_btn {
  background: #F56C6C;
  color: #fff;
  border-color: #F56C6C;
}
.cancle_btn {
  border-color: #F56C6C;
  color: #F56C6C;
}
.red {
  color: #F56C6C;
}
/* 内容表格 */
.banner_table {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 10px;
  height: 640px;
  position: relative;
  /* overflow: hidden;
   */
}
/* 标题 */
.banner_table section {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
}
.banner_table .el-col-22 p {
  width: 86px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
  margin-top: 0;
}
/* 新增按钮 */
.banner_table .el-col-2 p {
  width: 104px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
.qRCode{
  width: 230px;
  height: 36px;
  line-height: 36px;
  background-color: #F56C6C;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
.imgDialog {
  width: 100%;
  height: 360px;
  margin: 0 auto;
  text-align: center;
}
.imgDialog>img {
  width:auto; 
  height:auto; 
  max-width:90%;
  max-height:90%;
}
.imgDialog>p {
  width: 100%;
  height:50px;
  font-size: 16px;
}
/* 新增页面 */
.add_banner {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 20px;
  padding-bottom: 30px;
  position: relative;
}
.add_banner .el-col-24 {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}
.add_banner .el-col-24 p {
  width: 110px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin: 0;
  margin-left: 40px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
}
.add_banner input {
  border: 1px solid #f2f2f2;
  background: #fff !important;
}
</style>


// WEBPACK FOOTER //
// brand.vue?e197d86e